export default __webpack_public_path__ + "static/media/14.6efb79d1.jpg";